import { render } from "./SendJournalToSignature.vue?vue&type=template&id=16cb9aff"
import script from "./SendJournalToSignature.vue?vue&type=script&lang=js"
export * from "./SendJournalToSignature.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__